<template>
  <div class="help-center-new">
    <template v-if="categoryTreeData.children && categoryTreeData.children.length > 0">
      <div class="head">
        <span @click="toHome()">{{ $t('helpCenterNew.m00000') }}</span>><span @click="toLevel2()">{{ categoryTreeData.title }}</span>>{{ categoryTreeData.children[0].title }}
      </div>
      <div class="list-box">

          <div
            class="item"
            v-for="item in categoryTreeData.children[0].document"
            @click="toDetail(item.document_id)"
          >
            <p class="title">{{ item.title }}</p>
            <span class="arrow"></span>
          </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  data() {
    return {
      id: '',
      categoryTreeData: []
    }
  },
  created() {
    this.id = this.$route.query.id;
    this.getHelpCategoryTree()
  },
  methods: {
    getHelpCategoryTree(){
      this.$apis.getHelpCategoryTree({
        category_id: this.id,
        display: 'document'
      }).then(res => {
        if(res.tree){
          this.categoryTreeData = res.tree[0];
        }
      })
    },
    toDetail(id){
      this.$router.push({
        path: `/help-center/details`,
        query: {
          ...this.$route.query,
          id
        }
      })
    },
    toHome(){
      this.$router.push({
        path: `/help-center`,
        query: {
          ...this.$route.query,
        }
      })
    },
    toLevel2(){
      this.$router.push({
        path: `/help-center/level2`,
        query: {
          ...this.$route.query,
          id: this.categoryTreeData.parent_id
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
.help-center-new{
  .head{
    padding: 20px 32px;
    color: #747377;
  }
  .list-box{
    padding: 0 32px;
    .item{
      display: flex;
      align-items: center;
      padding: 34px 0;
      position: relative;
      &:after{
        content: '';
        position: absolute;
        left: -50%;
        bottom: 0;
        width: 200%;
        height: 1px;
        background: #EBEBEB;
        transform: scale(0.5);
      }
      .title{
        flex: 1;
        font-size: 32px;
        font-weight: 500;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .arrow{
        width: 32px;
        height: 32px;
        background: url("../../assets/images/help-center-new/arrow.png") no-repeat;
        background-size: 100% 100%;
      }
    }
  }
}

</style>